import { filter, map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionPendingInventoryInfoReceived, TypeActionPendingInventoryInfo, } from "../actionPendingInventoryInfo";
export var epicPendingInventoryInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionAuth.Login ||
            action.type === TypeActionPendingInventoryInfo.RequestUpdate;
    }), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.PendingInventoryInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), map(function (res) { return actionPendingInventoryInfoReceived(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/epics/epicPendingInventoryInfo.ts
// module id = 2037
// module chunks = 3